import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { attentionDemands } from '../../data/deckContent';
export function ProblemSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The problem" index={2} data-id="element-136" data-mp="gy8hrtqgdzz9">
      <div className="grid grid-cols-[1fr_1fr] items-center gap-[6%]" data-id="element-137" data-mp="kxh8squ3zjr4">
        <div data-id="element-138" data-mp="kztzbsdxn2fs">
          <h2 className="text-[clamp(28px,4.2vw,74px)] font-semibold leading-[1.05] tracking-tight text-white" data-id="element-139" data-mp="18nv5iunn26s1">
            HCP attention is expensive.
          </h2>
          <p className="mt-[3vh] text-[clamp(13px,1.4vw,26px)] font-light leading-snug text-white/55" data-id="element-140" data-mp="1dosld0l6eoqd">
            Dental professionals are constantly asked to do more with the few
            minutes they have between patients.
          </p>
        </div>

        <div data-id="element-141" data-mp="1rm7i6qdrdysd">
          <ul className="space-y-[1.6vh]" data-id="element-142" data-mp="1rlnxj1wq4wan">
            {attentionDemands.map((demand, i) => <motion.li key={demand} initial={reduced ? false : {
            opacity: 0,
            x: 16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.4,
            delay: 0.06 * i,
            ease: 'easeOut'
          }} className="flex items-center gap-[1.2vw] rounded-full border border-white/10 bg-white/[0.03] px-[1.6vw] py-[1.5vh]" data-id="element-143" data-mp="1wdz8r0wx04ii" data-mpi={i}>
                <span className="h-[0.55vw] w-[0.55vw] min-h-[5px] min-w-[5px] rounded-full bg-white/25" data-id="element-144" data-mp="sb94xjywee1f" />
                <span className="text-[clamp(13px,1.5vw,28px)] font-light text-white/80" data-id="element-145" data-mp="1624ktg7tdvei">
                  {demand}
                </span>
              </motion.li>)}
          </ul>

          <p className="mt-[3.2vh] text-[clamp(14px,1.6vw,30px)] font-medium leading-snug text-white" data-id="element-146" data-mp="1g0ajloybqlf5">
            Solventum should not demand attention.{' '}
            <span className="text-[color:var(--sv-green)]" data-id="element-147" data-mp="3hsq9y6eui3jq">
              Solventum should earn it.
            </span>
          </p>
        </div>
      </div>
    </SlideFrame>;
}